export const SET_JOB_TEMPLATES = 'SET_JOB_TEMPLATES';